/* TWH bootstrap guard: todo el JS corre con el DOM completo. */
console.log("%cTWH theme v1.8 · build 2026-09-16 · numeros texto plano mobile/tablet","color:#E2A33E;font-weight:bold");
(function(){
  function __twhInit(){

try{ document.documentElement.classList.remove("twh-nojs"); }catch(e){}

const header=document.getElementById('siteHeader');
/* Header theme: glass over dark sections, solid pine over light ones (section under the header wins) */
const themedSections=[...document.querySelectorAll('[data-bg]')];
function headerTheme(){
  header.classList.toggle('is-scrolled', window.scrollY>8);
  const probe=header.getBoundingClientRect().height+2;
  let best=null, bestTop=-Infinity;
  themedSections.forEach(s=>{ const r=s.getBoundingClientRect(); if(r.top<=probe && r.bottom>probe && r.top>bestTop){ bestTop=r.top; best=s; } });
  header.dataset.theme = best ? best.dataset.bg : 'dark';
}
headerTheme(); window.addEventListener('scroll',headerTheme,{passive:true}); window.addEventListener('resize',headerTheme,{passive:true});
const toggle=document.getElementById('menuToggle'), menu=document.getElementById('mobileMenu');
if(toggle){
  toggle.addEventListener('click',()=>{const o=menu.classList.toggle('is-open');toggle.classList.toggle('is-open',o);toggle.setAttribute('aria-expanded',o);});
  menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{menu.classList.remove('is-open');toggle.classList.remove('is-open');toggle.setAttribute('aria-expanded',false);}));
}
const io=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14,rootMargin:'0px 0px -8% 0px'});
document.querySelectorAll('.reveal').forEach((el,i)=>{el.style.transitionDelay=(Math.min(i,6)*60)+'ms';io.observe(el);});
const gt=document.getElementById('glassToggle');
if(gt){gt.addEventListener('click',()=>{const on=document.body.classList.toggle('hdr-glass');document.getElementById('glassState').textContent=on?'on':'off';});}

/* Keep all footer chips on a single row (desktop): shrink font just enough to fit */
function fitChips(){
  const c=document.querySelector('.footer-badges .container');
  if(!c) return;
  const badges=[...c.querySelectorAll('.badge')];
  badges.forEach(b=>b.style.removeProperty('--pad-x'));
  if(window.innerWidth<=820){ c.style.removeProperty('--chip-fs'); return; }
  // 1) fit font so the 5 chips sit on a single row (min 11px safety)
  let fs=17;
  c.style.setProperty('--chip-fs', fs+'px');
  let guard=0;
  while(c.scrollWidth>c.clientWidth+1 && fs>11 && guard<60){ fs-=0.5; c.style.setProperty('--chip-fs', fs+'px'); guard++; }
  // 2) distribute the leftover space as internal padding so the row aligns to the box edges
  const gap=14, n=badges.length;
  const chipsW=badges.reduce((a,b)=>a+b.getBoundingClientRect().width,0);
  const leftover=c.clientWidth - chipsW - gap*(n-1);
  if(leftover>2){
    const extra=Math.min(leftover/(2*n), 40); // cap so pills don't get absurdly wide on ultra-wide
    badges.forEach(b=>b.style.setProperty('--pad-x', (15+extra)+'px'));
  }
}
window.addEventListener('resize', fitChips, {passive:true});
if(document.fonts && document.fonts.ready){ document.fonts.ready.then(fitChips); }
fitChips();

/* ---------- 06 · The Door — score counter (0 → 100) ---------- */
(function(){
  const scoreEl=document.getElementById('doorScore');
  const cert=document.getElementById('doorCert');
  if(!scoreEl||!cert) return;
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  let running=false, fired=false;
  const easeOutExpo=x=>x>=1?1:1-Math.pow(2,-10*x);
  function runCount(){
    if(reduced){scoreEl.textContent='100';return;}
    if(running) return; running=true;
    const D=2300, t0=performance.now();
    scoreEl.textContent='0';
    (function frame(now){
      const p=Math.min(1,(now-t0)/D);
      scoreEl.textContent=Math.round(easeOutExpo(p)*100);
      if(p<1){requestAnimationFrame(frame);}
      else{ scoreEl.animate([{transform:'scale(1)'},{transform:'scale(1.045)',offset:.4},{transform:'scale(1)'}],{duration:420,easing:'cubic-bezier(.34,1.3,.64,1)'}); running=false; }
    })(performance.now());
  }
  const io=new IntersectionObserver((es)=>{es.forEach(e=>{ if(e.isIntersecting && !fired){ fired=true; setTimeout(runCount,300);} });},{threshold:.35});
  io.observe(cert);
  cert.querySelector('.cert-paper').addEventListener('click',runCount);
})();

/* ---------- 10 · Three Readers — filing cabinet (scroll-scrub + click) ---------- */
(function(){
  document.querySelectorAll('.readers').forEach(function(readers){
  const track=readers.querySelector('.rd-track');
  const pin=readers.querySelector('.rd-pin');
  const stage=readers.querySelector('.rd-stage');
  const head=readers.querySelector('.rd-head');
  const folders=[...readers.querySelectorAll('.folder')];
  const N=folders.length;
  const CHECK='<svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9.4" cy="9.25" r="8.4" stroke="currentColor" stroke-width="1.1"/><path d="M5.6 9.7 L8.2 12.2 L13.3 6.3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  readers.querySelectorAll('.rd-icon').forEach(el=>el.innerHTML=CHECK);
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  const FLOW=['one','two','three'];
  const clamp=(lo,v,hi)=>Math.max(lo,Math.min(hi,v));

  let sh=0, cur=null, P=null;
  /* SOLO tablet (601–860) usa el fallback apilado estático. Mobile ≤600 usa
     el mecanismo desktop (scroll-scrub + click) con layout mobile. */
  const isMobile=()=>false;
  const isPhone=()=>matchMedia('(max-width:600px)').matches;   /* móvil ≤600: params compactos */
  const isTablet=()=>matchMedia('(min-width:601px) and (max-width:1119px)').matches;  /* tablet: scroll-scrub + clic (como desktop), peeks pegados al contenido */

  /* Tab clip-path: the solapa is a FIXED-size flap anchored to the centred
     content column; only the flat body segments stretch full-bleed to the
     screen edges (so the tab never balloons on wide screens). Offsets are
     taken from the Figma frame (column-left = 78.42 in the 1440 canvas;
     left tab flat 0->440, bevel ->500; right tab mirrored). */
  function measureClips(){
    const vw=readers.getBoundingClientRect().width;
    const gutter=clamp(20, vw*0.05, 48);
    const colMax=parseFloat(getComputedStyle(readers).getPropertyValue('--rd-col'))||1280;
    const col=Math.min(colMax, vw-gutter*2);
    const cx=Math.max(gutter,(vw-col)/2);   // column left edge
    const cr=cx+col;                          // column right edge
    const k=col/1280;
    // shape taken from the master vector: flat top anchored at the column edge,
    // a short steep bevel (~22px) toward the body and a tiny soft bevel (~6px) on
    // the outer corner. Widths scale with the column (k); tab band stays 50px tall.
    const mob=vw<=600;
    const Lb=mob?2:6*k, Rb=mob?22:22*k, FLAT=mob?Math.min(col-88,226):400*k;   // mobile: solapa plana más ancha (frame)
    readers.style.setProperty('--flapw', FLAT+'px');   // keep label/title centring box in sync
    const lb0=cx-Lb, lTop=cx, lFlatR=cx+FLAT, lBev=cx+FLAT+Rb;
    readers.style.setProperty('--clip-left',
      'polygon(0 50px, '+lb0+'px 50px, '+lTop+'px 0, '+lFlatR+'px 0, '+lBev+'px 50px, 100% 50px, 100% 100%, 0 100%)');
    const rTop=cr, rFlatL=cr-FLAT, rBev=cr-FLAT-Rb, rb1=cr+Lb;
    readers.style.setProperty('--clip-right',
      'polygon(0 50px, '+rBev+'px 50px, '+rFlatL+'px 0, '+rTop+'px 0, '+rb1+'px 50px, 100% 50px, 100% 100%, 0 100%)');
  }

  /* Adaptive vertical layout. Reading position is anchored to the section
     header (so the title always keeps its distance from the first tab), the
     tab steps are fixed, and the deepest state is solved so colour is left
     below the last folder. */
  function computeParams(){
    /* ---- MOBILE ≤600: parámetros derivados de los frames (Figma 315:1028…),
       misma mecánica adaptativa que desktop pero con constantes mobile. ---- */
    if(isPhone()){
      const FRAME_TOP=72;                                    // header fijo del sitio
      const BAND=Math.round(clamp(40, sh*0.098, 83));        // franja pergamino sobre la 1ª solapa (frame ≈83@844)
      const OPEN_TOP=FRAME_TOP+BAND;                         // top de la carpeta abierta (frame=155@844)
      const th=head.getBoundingClientRect().height;
      head.style.top=Math.round(FRAME_TOP+(BAND-th)/2)+'px';
      const OFFSET=Math.round(clamp(56, sh*0.094, 79));      // top del contenido dentro de la carpeta (frame=79@844)
      let ch=0; folders.forEach(f=>{ ch=Math.max(ch, f.querySelector('.rd-inner').offsetHeight); });
      const BOTTOM=10;
      const TABBAND=50, GAP=8;                               // solapa = 50px de alto; se busca dejar GAP entre solapas apiladas
      const maxFit=Math.floor((sh - OPEN_TOP - OFFSET - ch - BOTTOM)/(N-1));
      let step=clamp(34, TABBAND+GAP, maxFit);               // paso = 58 (gap ~8) sin exceder lo que entra en pantallas cortas
      const peekNear=Math.round(clamp(82, sh*0.128, 116));   // cuánto asoma la última carpeta abajo
      folders.forEach(f=>{ f.querySelector('.rd-content').style.top=OFFSET+'px'; });
      return {OPEN_TOP, OFFSET, step, peekNear, ch};
    }
    const FRAME_TOP=72;                                      // fixed site header height = visible top of the strip
    const BAND=Math.round(clamp(100, sh*0.145, 132));        // parchment strip above the first tab
    const OPEN_TOP=FRAME_TOP+BAND;                           // reading position of an open folder
    const th=head.getBoundingClientRect().height;            // header block height
    head.style.top=Math.round(FRAME_TOP+(BAND-th)/2)+'px';   // equal margin above (frame) and below (tab)
    const OFFSET=Math.round(clamp(70, sh*0.104, 96));        // content top within a folder
    let ch=0; folders.forEach(f=>{ ch=Math.max(ch, f.querySelector('.rd-inner').offsetHeight); });
    const BOTTOM=96;                                         // colour wanted below the deepest content
    let step=Math.floor((sh - OPEN_TOP - OFFSET - ch - BOTTOM)/(N-1));
    step=clamp(54, step, 92);
    const peekNear=Math.round(clamp(92, sh*0.128, 116));     // how much the last folder peeks at the bottom
    folders.forEach(f=>{ f.querySelector('.rd-content').style.top=OFFSET+'px'; });
    return {OPEN_TOP, OFFSET, step, peekNear, ch};
  }

  function posFor(oi){
    const res=[];
    for(let i=0;i<=oi;i++){            // already read (stacked at top) + the open one
      res[i]={top:P.OPEN_TOP + i*P.step, z:(i<oi ? 20+i : 30)};
    }
    const firstUnread=oi+1;
    if(firstUnread<N){
      // peek from the bottom, but never let the topmost peeker cover the open content
      const contentBottom=P.OPEN_TOP + oi*P.step + P.OFFSET + P.ch;
      const natural=sh - P.peekNear - (N-1-firstUnread)*P.step;
      /* tablet: las pestañas no leídas van pegadas bajo el contenido (no al fondo del viewport) */
      const topmost=isTablet() ? (contentBottom + 44) : Math.max(natural, contentBottom + 22);
      for(let i=firstUnread;i<N;i++){
        res[i]={top:Math.round(topmost + (i-firstUnread)*P.step), z:40+i};
      }
    }
    return res;
  }

  function layout(oi){
    stage.dataset.open=FLOW[oi];
    const map=posFor(oi);
    folders.forEach((f,i)=>{
      const isOpen=i===oi;
      f.classList.toggle('open',isOpen);
      f.querySelector('.rd-hit').setAttribute('aria-expanded',isOpen?'true':'false');
      f.style.top=map[i].top+'px';
      f.style.zIndex=map[i].z;
    });
  }
  function apply(oi){
    if(oi===cur) return;
    const first=cur===null; cur=oi;
    layout(oi);
    if(!first && !reduced){
      folders[oi].animate([{transform:'translateY(6px)'},{transform:'translateY(-3px)'},{transform:'translateY(0)'}],{duration:520,easing:'cubic-bezier(.34,1.3,.64,1)'});
    }
  }

  /* scroll-scrub: one -> two -> three, with a generous dwell on three */
  function scrubState(p){ return p<0.30 ? 0 : (p<0.62 ? 1 : 2); }
  const CLICK_P=[0.12,0.46,0.82];
  function onScroll(){
    if(isMobile()) return;
    const total=track.offsetHeight - pin.offsetHeight;
    const traveled=clamp(0, -track.getBoundingClientRect().top, Math.max(total,0));
    const p=total>0?traveled/total:0;
    apply(scrubState(p));
  }
  function goTo(idx){
    if(isMobile()) return;
    const total=track.offsetHeight - pin.offsetHeight;
    const trackTopDoc=window.scrollY + track.getBoundingClientRect().top;
    window.scrollTo({top:trackTopDoc + CLICK_P[idx]*total, behavior:reduced?'auto':'smooth'});
  }
  folders.forEach((f,idx)=>{
    const hit=f.querySelector('.rd-hit');
    hit.addEventListener('click',()=>goTo(idx));
    hit.addEventListener('keydown',e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); goTo(idx);} });
  });

  function setup(){
    measureClips();
    if(isMobile()){
      head.style.top='';
      folders.forEach(f=>{ f.classList.add('open'); f.style.top=''; f.style.zIndex=''; f.querySelector('.rd-content').style.top=''; });
      stage.dataset.open='one'; cur='mobile';
    }else{
      sh=pin.getBoundingClientRect().height;
      P=computeParams();
      cur=null; onScroll();
    }
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',setup,{passive:true});
  if(document.fonts&&document.fonts.ready){ document.fonts.ready.then(setup); }
  setup();
  });
})();


/* ---------- 13 · Guardrails — seamless marquee ribbon (multi-instancia) ---------- */
(function(){
  const tracks=document.querySelectorAll('.guard-track');
  if(!tracks.length) return;
  const words=['Be read.','Be retold.','Be acted on.'];
  const half=[]; for(let i=0;i<8;i++) words.forEach(w=>half.push(w));
  const units=half.concat(half); /* duplicate so translateX(-50%) loops seamlessly */
  const html=units.map(w=>'<span class="guard-unit"><span class="guard-mk"><svg viewBox="0 0 58 54" aria-hidden="true"><use href="#gm"/></svg></span><span class="guard-txt">'+w+'</span></span>').join('');
  tracks.forEach(t=>{ t.innerHTML=html; });
})();


/* ===================== 13 · Guardrails — MÓDULO "la pluma dibuja el isotipo" =====================
   mountPenDraw(host, opts): dibuja el path maestro #pfcPav trazo por trazo con una pluma,
   y (con settleTo) hace volar el dibujo a su lugar en el layout. Multi-instancia (uid interno).
   Fuente: claude/twh-anim/twh-pen-draw.html (módulo aprobado). No editar de memoria. */
window.mountPenDraw = function(host, opts){
  opts = Object.assign({drawMs:8250, cuajeMs:900, settleMs:900, autoplay:true, penTilt:34, skipOn:['click','wheel','keydown'], keepPen:false, settleTo:null, straightToFinal:false, onDone:null}, opts||{});
  const NS='http://www.w3.org/2000/svg';
  const reduced = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const LW = 16;
  /* Secuencia (geometría medida sobre el maestro; t0/t1 normalizados 0..1) */
  const STROKES = [{"n": "puerta", "d": "M 273.5 540 L 273.5 236 A 125.75 125.75 0 0 1 525 236 L 525 540 L 273.5 540", "t0": 0.0, "t1": 0.1009}, {"n": "raja-izq", "d": "M 273.5 540 L 142 695", "t0": 0.1362, "t1": 0.1815}, {"n": "raja-der", "d": "M 525 540 L 658 695", "t0": 0.1967, "t1": 0.2421}, {"n": "arco", "d": "M 142 695 A 392.5 392.5 0 1 1 658 695", "t0": 0.2799, "t1": 0.411}, {"n": "p1-naranja", "d": "M 100 154 C 160 152, 220 152, 260 155 C 330 170, 385 220, 400 284 L 400 540", "t0": 0.4513, "t1": 0.532}, {"n": "p1-verde", "d": "M 699 154 C 639 152, 579 152, 539 155 C 469 170, 414 220, 400 284 L 400 730", "t0": 0.5451, "t1": 0.6309}, {"n": "p2-naranja", "d": "M 62 205 C 110 212, 180 200, 250 206 C 292 210, 328 224, 338.5 247 L 338.5 540", "t0": 0.6611, "t1": 0.7267}, {"n": "p2-verde", "d": "M 463 127 C 447 131, 421 143, 400 160 C 375 172, 345 205, 338.5 247 L 338.5 545 L 314 630", "t0": 0.7398, "t1": 0.8154}, {"n": "p3-naranja", "d": "M 737 205 C 689 212, 619 200, 549 206 C 507 210, 471 224, 460.5 247 L 460.5 540", "t0": 0.8457, "t1": 0.9112}, {"n": "p3-verde", "d": "M 336 127 C 352 131, 378 143, 400 160 C 424 172, 454 205, 460.5 247 L 460.5 545 L 485 630", "t0": 0.9244, "t1": 1.0}];
  const ISO_D = document.getElementById('pfcPav').getAttribute('d');

  /* ---- DOM ---- */
  const svg=document.createElementNS(NS,'svg'); svg.setAttribute('class','pd-svg'); svg.setAttribute('viewBox','0 0 800 732'); svg.setAttribute('aria-hidden','true');
  const uid='pd'+Math.random().toString(36).slice(2,7);
  const defs=document.createElementNS(NS,'defs');
  const f=document.createElementNS(NS,'filter'); f.id=uid+'-sh'; f.setAttribute('x','-80%'); f.setAttribute('y','-30%'); f.setAttribute('width','260%'); f.setAttribute('height','160%');
  const fs=document.createElementNS(NS,'feDropShadow'); fs.setAttribute('dx','4'); fs.setAttribute('dy','7'); fs.setAttribute('stdDeviation','5'); fs.setAttribute('flood-color','#000'); fs.setAttribute('flood-opacity','.45');
  f.appendChild(fs); defs.appendChild(f); svg.appendChild(defs);
  const layer=document.createElementNS(NS,'g'); svg.appendChild(layer);
  const solid=document.createElementNS(NS,'path'); solid.setAttribute('class','pd-solid'); solid.setAttribute('d',ISO_D); svg.appendChild(solid);
  const glow=document.createElementNS(NS,'circle'); glow.setAttribute('class','pd-glow'); glow.setAttribute('r','16'); glow.setAttribute('fill','#f2d79b'); svg.appendChild(glow);
  const pen=document.createElementNS(NS,'g'); pen.setAttribute('class','pd-pen');
  pen.innerHTML = `<g filter="url(#${uid}-sh)">
    <path d="M -22 -118 L -22 -458 Q -22 -484 0 -484 Q 22 -484 22 -458 L 22 -118 Z" fill="#0b2a25" stroke="#b8862c" stroke-width="1.4"/>
    <path d="M 8 -118 L 8 -472 Q 22 -472 22 -458 L 22 -118 Z" fill="#061c18" opacity=".55"/>
    <rect x="-14" y="-452" width="7" height="326" rx="3.5" fill="#2a7463" opacity=".55"/>
    <rect x="-22.5" y="-450" width="45" height="7" fill="#d8a147"/>
    <rect x="-23" y="-124" width="46" height="12" rx="2" fill="#d8a147"/><rect x="-23" y="-124" width="46" height="4" fill="#eabf72"/>
    <path d="M -19 -112 L -19 -78 Q -19 -72 -13 -72 L 13 -72 Q 19 -72 19 -78 L 19 -112 Z" fill="#0a2622" stroke="#b8862c" stroke-width="1"/>
    <path d="M 6 -112 L 6 -74 L 13 -72 Q 19 -72 19 -78 L 19 -112 Z" fill="#061c18" opacity=".5"/>
    <rect x="-17" y="-78" width="34" height="8" rx="2" fill="#c9962f"/>
    <path d="M -16 -72 Q 0 -70 16 -72 L 3.5 -9 Q 0 -3 0 0 Q 0 -3 -3.5 -9 Z" fill="#d8a147" stroke="#9c6f2a" stroke-width="1"/>
    <path d="M 0 -71 L 3.5 -9 Q 0 -3 0 0 Z" fill="#c08a2c"/>
    <line x1="0" y1="-60" x2="0" y2="-12" stroke="#6f4e18" stroke-width="1.5"/><circle cx="0" cy="-60" r="3.4" fill="#6f4e18"/>
    <path d="M -9 -49 Q -4.5 -57 0 -49 M 0 -49 Q 4.5 -57 9 -49 M -5.5 -42 Q 0 -50 5.5 -42" fill="none" stroke="#8a6320" stroke-width="1" opacity=".9"/>
    <path d="M -9 -64 L -3.5 -20" stroke="#f2d79b" stroke-width="1.4" opacity=".85" stroke-linecap="round"/><circle cx="0" cy="-1.5" r="2.6" fill="#eabf72"/>
  </g>`;
  svg.appendChild(pen);
  host.appendChild(svg);

  const paths=STROKES.map(s=>{ const p=document.createElementNS(NS,'path'); p.setAttribute('d',s.d); p.setAttribute('class','pd-guide'); p.setAttribute('stroke-width',LW); layer.appendChild(p); return p; });
  const lens=paths.map(p=>p.getTotalLength());
  paths.forEach((p,i)=>{ p.style.strokeDasharray=lens[i]; p.style.strokeDashoffset=lens[i]; p.style.opacity=0; });

  /* ---- motor ---- */
  const easeIO=x=>x<.5?4*x*x*x:1-Math.pow(-2*x+2,3)/2;
  const penAngle=t=>opts.penTilt+7*Math.cos((t+90)*Math.PI/180);
  const setPen=(x,y,a,sc,op)=>{ pen.setAttribute('transform',`translate(${x} ${y}) rotate(${penAngle(a)}) scale(${sc})`); pen.style.opacity=op; };
  const ptAng=(p,len,u)=>{ u=Math.max(0,Math.min(1,u)); const a=p.getPointAtLength(u*len), b=p.getPointAtLength(Math.min(len,u*len+1)); return {x:a.x,y:a.y,ang:Math.atan2(b.y-a.y,b.x-a.x)*180/Math.PI-90}; };
  let raf=null, t0=0, done=false, paused=false;

  function reset(){
    paths.forEach((p,i)=>{ p.style.strokeDashoffset=lens[i]; p.style.opacity=0; });
    layer.style.transition='none'; layer.style.opacity=1; solid.style.transition='none'; solid.style.opacity=0; glow.style.opacity=0;
    pen.style.transition='none'; svg.style.transition='none'; svg.style.transform='none';
    const s=ptAng(paths[0],lens[0],0); setPen(s.x,s.y,s.ang,1,0); done=false; paused=false;
  }
  function drawAt(p){
    let active=-1;
    STROKES.forEach((g,i)=>{
      if(p>=g.t1){ paths[i].style.strokeDashoffset=0; paths[i].style.opacity=1; }
      else if(p<g.t0){ paths[i].style.strokeDashoffset=lens[i]; paths[i].style.opacity=0; }
      else { const u=easeIO((p-g.t0)/(g.t1-g.t0)); paths[i].style.strokeDashoffset=lens[i]*(1-u); paths[i].style.opacity=1; active=i; }
    });
    if(active>=0){
      const u=easeIO((p-STROKES[active].t0)/(STROKES[active].t1-STROKES[active].t0));
      const q=ptAng(paths[active],lens[active],u); setPen(q.x,q.y,q.ang,1,1);
      glow.setAttribute('cx',q.x); glow.setAttribute('cy',q.y); glow.style.opacity=.5;
    } else {
      let nxt=STROKES.findIndex(g=>p<g.t0); if(nxt<0)nxt=STROKES.length-1;
      let prv=-1; STROKES.forEach((g,i)=>{ if(p>=g.t1) prv=i; });
      const b=ptAng(paths[nxt],lens[nxt],0);
      if(prv>=0){ const a=ptAng(paths[prv],lens[prv],1);
        const u=easeIO(Math.max(0,Math.min(1,(p-STROKES[prv].t1)/(STROKES[nxt].t0-STROKES[prv].t1))));
        const lift=Math.sin(u*Math.PI); setPen(a.x+(b.x-a.x)*u, a.y+(b.y-a.y)*u, b.ang, 1+0.14*lift, 0.35+0.4*(1-lift));
      } else setPen(b.x,b.y,b.ang,1,.6);
      glow.style.opacity=0;
    }
  }
  function finish(){
    if(!opts.straightToFinal){ layer.style.transition=`opacity ${opts.cuajeMs}ms ease`; layer.style.opacity=0; }
    if(!opts.straightToFinal){ solid.style.transition=`opacity ${opts.cuajeMs}ms ease`; solid.style.opacity=1; }
    glow.style.opacity=0;
    if(!opts.keepPen){ pen.style.transition='opacity .35s, transform .6s cubic-bezier(.2,.7,.2,1)';
      const l=ptAng(paths[paths.length-1],lens[paths.length-1],1); setPen(l.x+520,l.y-300,l.ang+16,1,0); }
    const after=()=>{ done=true; if(opts.onDone) opts.onDone(); };
    if(opts.settleTo){
      setTimeout(()=>requestAnimationFrame(()=>{
        const big=svg.getBoundingClientRect(), tgt=opts.settleTo.getBoundingClientRect();
        const s=tgt.width/big.width, dx=(tgt.left+tgt.width/2)-(big.left+big.width/2), dy=(tgt.top+tgt.height/2)-(big.top+big.height/2);
        svg.style.transformOrigin='center center'; svg.style.transition=`transform ${opts.settleMs}ms cubic-bezier(.2,.7,.2,1)`;
        svg.style.transform=`translate(${dx}px,${dy}px) scale(${s})`;
        setTimeout(after, opts.settleMs-40);
      }), opts.cuajeMs-150);
    } else setTimeout(after, opts.cuajeMs);
  }
  function frame(now){ if(paused) return; let p=(now-t0)/opts.drawMs; if(p>1)p=1; drawAt(p); if(p<1) raf=requestAnimationFrame(frame); else finish(); }
  function play(){ cancelAnimationFrame(raf); reset(); if(reduced){ layer.style.opacity=0; solid.style.opacity=1; done=true; if(opts.onDone) opts.onDone(); return; } t0=performance.now(); raf=requestAnimationFrame(frame); }
  function stop(){ paused=true; cancelAnimationFrame(raf); }
  function skip(){ if(done) return; stop(); paths.forEach(p=>{p.style.opacity=0}); layer.style.opacity=0; if(!opts.straightToFinal){ solid.style.transition='none'; solid.style.opacity=1; } pen.style.opacity=0; done=true; if(opts.onDone) opts.onDone(); }
  function seek(p){ stop(); drawAt(Math.max(0,Math.min(1,p))); }
  const onSkip=()=>{ if(!done && t0) skip(); };
  (opts.skipOn||[]).forEach(ev=>window.addEventListener(ev,onSkip,{passive:true}));
  function destroy(){ stop(); (opts.skipOn||[]).forEach(ev=>window.removeEventListener(ev,onSkip)); svg.remove(); }

  reset();
  if(opts.autoplay) play();
  return {play, stop, seek, skip, destroy, svg};
};

/* ---- Enganche de Guardrails: al centrarse el frame, DETIENE el scroll y dibuja; al terminar suelta.
   El skip NO es sensible: ignora la inercia de llegada, espera a que el scroll se aquiete + un minimo
   de reproduccion, y recien ahi un scroll DELIBERADO (no un roce) saltea. Una sola vez por carga.
   TODOS los anchos (desktop + tablet + móvil, decisión usuario 2026-09-15) + sin reduced-motion.
   En táctil el skip usa touchmove. Velocidad de dibujo -25% (más lenta). Si no corre, frame estático. */
(function(){
  if(matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var NARROW=matchMedia('(max-width:1119px)').matches;
  var DRAW_MS=Math.round((NARROW?4200:6350)*1.25);   // -25% velocidad → 5250 (≤1119) / 7938 (≥1120)

  var docEl=document.documentElement;
  function lockScroll(){ var sb=window.innerWidth-docEl.clientWidth; docEl.style.overflow='hidden'; if(sb>0) docEl.style.paddingRight=sb+'px'; }
  function unlockScroll(){ docEl.style.overflow=''; docEl.style.paddingRight=''; }

  document.querySelectorAll('.guard').forEach(function(sec){
    var host=sec.querySelector('.pd-host'), stage=sec.querySelector('.guard-pen-stage'), mark=sec.querySelector('.guard-mark');
    if(!host||!stage||!mark) return;
    sec.classList.add('guard-anim');

    /* SKIP + POSICIÓN FINAL:
       - Se ve el dibujo un instante (MIN_PLAY) y luego un scroll deliberado modesto lo saltea.
       - Al saltear (o al terminar), el scroll queda ABSORBIDO hasta que se aquieta → NO te dispara
         al footer: transiciona a la posición final del frame y recién ahí suelta el scroll. */
    var MIN_PLAY=700, GAP=250, SKIP_DELTA=90, RELEASE_QUIET=220, ABSORB_MAX=1500;
    var fired=false, locked=false, finished=false, doneOnce=false, playStart=0, lastGesture=0, accum=0, safety=0, finishAt=0;

    var anim=window.mountPenDraw(host,{
      autoplay:false, drawMs:DRAW_MS, cuajeMs:200, settleMs:900, straightToFinal:true, settleTo:mark, skipOn:[],
      onDone:function(){
        if(doneOnce) return; doneOnce=true; finished=true; finishAt=performance.now();
        mark.style.opacity=1; stage.style.opacity=0;                    // el iso se asienta como mark
        setTimeout(function(){ sec.classList.add('guard-lit'); }, 220); // cascada eyebrow→texto→cinta
        setTimeout(function(){ sec.classList.remove('guard-takeover'); }, 900);
        requestAnimationFrame(releaseWatcher);                          // suelta cuando el scroll se aquiete
      }
    });

    function endTakeover(){ sec.classList.remove('guard-takeover'); }
    function release(){
      if(!locked) return; locked=false; unlockScroll();
      window.removeEventListener('wheel',onWheel,{passive:false});
      window.removeEventListener('touchmove',onTouch,{passive:false});
      window.removeEventListener('keydown',onKey,true);
      window.removeEventListener('click',onClick,true);
      window.removeEventListener('hashchange',onHash);
      clearTimeout(safety);
    }
    function onHash(){ endTakeover(); release(); }
    function doSkip(){ if(locked && !finished) anim.skip(); }   // => onDone => releaseWatcher
    function armed(){ return performance.now()-playStart > MIN_PLAY; }  // ya se vio arrancar el dibujo
    function releaseWatcher(){
      if(!locked) return;
      var now=performance.now();
      // suelta cuando paraste de scrollear (o tras un máximo), NUNCA en medio de tu impulso → no vas al footer
      if( (now-lastGesture)>RELEASE_QUIET || (now-finishAt)>ABSORB_MAX ){ release(); return; }
      requestAnimationFrame(releaseWatcher);
    }
    function onWheel(e){
      e.preventDefault();                            // absorbe el scroll (el frame no se mueve)
      var now=performance.now(), dy=Math.abs(e.deltaY)||Math.abs(e.deltaX)||1;
      if(now-lastGesture>GAP) accum=0;               // hueco => intención de scroll nueva
      lastGesture=now;
      if(finished || !armed()) return;               // viendo el dibujo / ya terminó: sólo absorbe
      accum+=dy; if(accum>SKIP_DELTA) doSkip();       // scroll deliberado => saltea a la posición final
    }
    function onTouch(e){
      e.preventDefault();
      var now=performance.now();
      if(now-lastGesture>GAP) accum=0;
      lastGesture=now;
      if(finished || !armed()) return; accum+=26; if(accum>SKIP_DELTA) doSkip();
    }
    var SK={'ArrowDown':1,'ArrowUp':1,'PageDown':1,'PageUp':1,' ':1,'Spacebar':1,'Home':1,'End':1};
    function onKey(e){ if(SK[e.key]){ e.preventDefault(); if(!finished && armed()) doSkip(); } }
    function onClick(e){
      var a=e.target && e.target.closest && e.target.closest('a[href]');
      if(a){ endTakeover(); release(); return; }      // click en un link: limpia y deja navegar
      if(!finished && armed()) doSkip();              // click deliberado: saltea
    }

    function trigger(){
      if(fired) return; fired=true;
      var rect=sec.getBoundingClientRect(), vh=innerHeight, delta=(rect.top+rect.height/2)-(vh/2);
      if(Math.abs(delta)>1) window.scrollBy(0,delta);       // centra exacto (salto mínimo)
      locked=true; lockScroll();
      playStart=lastGesture=performance.now();
      window.addEventListener('wheel',onWheel,{passive:false});
      window.addEventListener('touchmove',onTouch,{passive:false});
      window.addEventListener('keydown',onKey,true);
      window.addEventListener('click',onClick,true);
      window.addEventListener('hashchange',onHash);
      safety=setTimeout(function(){ if(locked && !finished) anim.skip(); }, DRAW_MS+900+3000);
      sec.classList.add('guard-takeover');
      mark.style.opacity=0; stage.style.display=''; stage.style.opacity=1;
      anim.play();
    }
    var prevC=null;
    function tick(){
      if(fired) return;
      var rect=sec.getBoundingClientRect(), vh=innerHeight;
      if(!rect.height){ prevC=null; return; }
      var c=(rect.top+rect.height/2)/vh, atBottom=(window.scrollY+vh)>=(docEl.scrollHeight-2);
      if(prevC!==null && (prevC-0.5)*(c-0.5)<=0) trigger();
      else if(Math.abs(c-0.5)<0.06) trigger();
      else if(atBottom && rect.top<vh*0.6 && rect.bottom>vh*0.3) trigger();
      prevC=c;
    }
    var ticking=false;
    function onScroll(){ if(ticking) return; ticking=true; requestAnimationFrame(function(){ ticking=false; tick(); }); }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    requestAnimationFrame(tick);
  });
})();


/* ---------- 13 · Guardrails — pen-draw MOBILE/TABLET vía IntersectionObserver — DESHABILITADO ----------
   El bloque de pin/skip anterior ahora cubre TODOS los anchos (decisión usuario 2026-09-15), así que
   este IO ya NO corre — evita montar el pen-draw dos veces en ≤1119. Se conserva por si se quiere volver
   al comportamiento sin freno en táctil (quitar el `return;`). */
(function(){
  return;
  if(!matchMedia('(max-width:1119px)').matches) return;
  if(matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  if(typeof window.mountPenDraw!=='function') return;
  document.querySelectorAll('.guard').forEach(function(sec){
    var host=sec.querySelector('.pd-host'), stage=sec.querySelector('.guard-pen-stage'), mark=sec.querySelector('.guard-mark');
    if(!host||!stage||!mark) return;
    sec.classList.add('guard-anim');
    var played=false;
    var anim=window.mountPenDraw(host,{
      autoplay:false, drawMs:4200, cuajeMs:200, settleMs:800, straightToFinal:true, settleTo:mark, skipOn:[],
      onDone:function(){ mark.style.opacity=1; stage.style.opacity=0; setTimeout(function(){ sec.classList.add('guard-lit'); },180); }
    });
    function fire(){ if(played) return; played=true; stage.style.display=''; stage.style.opacity=1; mark.style.opacity=0; anim.play(); }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) fire(); }); if(played) io.disconnect(); }, {threshold:0.4});
      io.observe(sec);
    } else { fire(); }
    /* seguridad: si por lo que sea no disparó en 4s pero el frame está a la vista, mostrar todo */
    setTimeout(function(){ if(!played){ var r=sec.getBoundingClientRect(); if(r.top<innerHeight && r.bottom>0) fire(); } }, 4000);
  });
})();


/* ---------- 07 · Services & Pricing — flip cards ---------- */
(function(){
 document.querySelectorAll('.px-cards-block').forEach(function(block){
  const cards=[...block.querySelectorAll('.px-cardwrap')];
  if(!cards.length) return;
  const pills=block.querySelectorAll('.px-pill');
  const btnPrices=pills[0], btnCompare=pills[1];
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  function flip(card){
    card.classList.toggle('flipped');
    if(!reduced){
      card.animate([{transform:'translateY(0) rotateZ(0)'},{transform:'translateY(-10px) rotateZ(-1deg)',offset:.42},{transform:'translateY(0) rotateZ(0)'}],{duration:740,easing:'cubic-bezier(.35,.6,.35,1)'});
      card.classList.add('lifting'); setTimeout(()=>card.classList.remove('lifting'),740);
    }
    updateButtons();
  }
  function updateButtons(){
    const f=cards.map(c=>c.classList.contains('flipped'));
    if(btnPrices) btnPrices.classList.toggle('off', f.every(v=>!v));
    if(btnCompare) btnCompare.classList.toggle('off', f.every(v=>v));
  }
  cards.forEach(c=>{
    c.addEventListener('click',e=>{ if(e.target.closest('.px-cta')) return; flip(c); });
    c.addEventListener('keydown',e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); flip(c);} });
  });
  function flipGroup(to){ let d=0; cards.forEach(c=>{ if(c.classList.contains('flipped')!==to){ setTimeout(()=>flip(c),d); d+=110; } }); }
  if(btnPrices) btnPrices.addEventListener('click',()=>flipGroup(false));
  if(btnCompare) btnCompare.addEventListener('click',()=>flipGroup(true));
 });
})();


/* ---------- single-file routing: click-based (works even where hash nav is blocked) ---------- */
(function(){
  const views=[...document.querySelectorAll('.pageview')];
  if(!views.length) return;
  const valid=new Set(views.map(v=>v.dataset.view));
  function show(name){
    if(!valid.has(name)) name='home';
    views.forEach(v=>{ v.hidden = (v.dataset.view!==name); });
    /* mark the active section link (pricing / method) */
    document.querySelectorAll('a[href="#pricing"],a[href="#method"],a[href="#who"],a[href="#news"]').forEach(a=>{
      const t=a.getAttribute('href').slice(1);
      if(t===name) a.setAttribute('aria-current','page'); else a.removeAttribute('aria-current');
    });
    try{ if(('#'+name)!==location.hash) history.replaceState(null,'','#'+name); }catch(e){}
    window.scrollTo(0,0);
    window.dispatchEvent(new Event('resize'));
    window.dispatchEvent(new Event('scroll'));
  }
  /* intercept clicks on in-page nav links so navigation never depends on hash routing */
  document.addEventListener('click', function(e){
    const a=e.target.closest('a[href^="#"]');
    if(!a) return;
    const t=a.getAttribute('href').slice(1);
    if(t==='pricing'||t==='method'||t==='who'||t==='news'||t==='article'||t==='free-score'){ e.preventDefault(); show(t); }
    else if(t==='home'||t==='top'){ e.preventDefault(); show('home'); }
    else if(t===''){ e.preventDefault(); }
  });
  window.addEventListener('hashchange', function(){ show((location.hash||'').replace('#','')||'home'); });
  show((location.hash||'').replace('#','')||'home');
})();


/* ---------- 05 · The Payoff — handwritten stat numerals (graphite) ---------- */
(function(){
  const section=document.querySelector('.py-payoff');
  if(!section) return;
  const SPEED=1040, STROKE_GAP=35, GLYPH_GAP=65;
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  function glyphGroups(svg){
    const groups=[...svg.querySelectorAll('mask > g')];
    const deps=[...svg.querySelectorAll('g.reveal > g.dep')];
    return groups.map((g,i)=>({strokes:[...g.querySelectorAll('path')], settle:g.querySelector('rect.settle'), dep:deps[i]}));
  }
  function write(num){
    const svg=num&&num.querySelector('svg.hand'); if(!svg) return Promise.resolve();
    const glyphs=glyphGroups(svg);
    /* mobile/tablet (≤1119px): sin animación — mostramos el número final directo y salimos.
       (el CSS ya lo deja visible; acá aseguramos las capas por si el JS tocó algo antes) */
    if(matchMedia('(max-width:1119px)').matches){
      glyphs.forEach(g=>{ g.settle&&g.settle.setAttribute('opacity','1'); g.dep&&g.dep.setAttribute('opacity','1'); g.strokes.forEach(p=>{ p.style.visibility='visible'; }); });
      return Promise.resolve();
    }
    if(reduced){ glyphs.forEach(g=>{g.settle&&g.settle.setAttribute('opacity','1'); g.dep&&g.dep.setAttribute('opacity','1');}); return Promise.resolve(); }
    /* Respaldo mobile: si el SVG no tiene layout, getTotalLength() da 0 → sin este chequeo
       el número quedaría invisible. Mostramos el número final directamente en ese caso. */
    let __plen=0; try{ glyphs.forEach(g=>g.strokes.forEach(p=>{ __plen+=p.getTotalLength(); })); }catch(e){ __plen=0; }
    if(__plen===0){ glyphs.forEach(g=>{ g.settle&&g.settle.setAttribute('opacity','1'); g.dep&&g.dep.setAttribute('opacity','1'); g.strokes.forEach(p=>{ p.style.visibility='visible'; }); }); return Promise.resolve(); }
    glyphs.forEach(g=>{ g.settle&&g.settle.setAttribute('opacity','0'); g.dep&&g.dep.setAttribute('opacity','0'); g.strokes.forEach(p=>{const len=p.getTotalLength(); p.style.strokeDasharray=len; p.style.strokeDashoffset=len; p.style.visibility='visible';}); });
    let t=0;
    glyphs.forEach(g=>{
      g.strokes.forEach(p=>{ const len=p.getTotalLength(); const dur=Math.max(60,(len/SPEED)*1000); p.animate([{strokeDashoffset:len},{strokeDashoffset:0}],{duration:dur,delay:t,easing:'cubic-bezier(.42,.05,.58,.95)',fill:'forwards'}); t+=dur+STROKE_GAP; });
      if(g.settle) g.settle.animate([{opacity:0},{opacity:1}],{duration:75,delay:Math.max(0,t-15),fill:'forwards'});
      if(g.dep) g.dep.animate([{opacity:0},{opacity:1}],{duration:130,delay:Math.max(0,t-15),fill:'forwards'});
      t+=GLYPH_GAP;
    });
    return new Promise(res=>setTimeout(res,t+40));
  }
  const nums=[1,2,3].map(i=>document.getElementById('num'+i));
  const drawn=new Set();
  function drawOne(n){ if(!n||drawn.has(n)) return Promise.resolve(); drawn.add(n); try{ return write(n); }catch(e){ return Promise.resolve(); } }
  function redraw(n){ if(!n) return; drawn.add(n); try{ write(n); }catch(e){} }
  async function runAll(){ for(const n of nums){ await drawOne(n); await new Promise(r=>setTimeout(r,75)); } }
  let started=false;
  function go(){ if(started) return; started=true; const fr=(document.fonts&&document.fonts.ready)?document.fonts.ready:Promise.resolve(); fr.then(()=>setTimeout(runAll,300)); }
  /* section-level cascade (left→right) SÓLO cuando los 3 van en fila (desktop + tablet):
     apilados (móvil) dibujaría los de abajo fuera de pantalla → no se ven animar; ahí manda el IO por-número. */
  const stats=section.querySelector('.py-stats');
  const isRow=()=> getComputedStyle(stats).flexDirection.indexOf('row')===0;
  const io=new IntersectionObserver((es)=>{ es.forEach(e=>{ if(e.isIntersecting && isRow()) go(); }); },{threshold:.12});
  io.observe(section);
  /* per-numeral: cada número dibuja al entrar en pantalla (clave en móvil apilado; también respaldo en fila) */
  const numIO=new IntersectionObserver((es)=>{ es.forEach(e=>{ if(e.isIntersecting){ drawOne(e.target); numIO.unobserve(e.target); } }); },{threshold:.2});
  nums.forEach(n=>{ if(n) numIO.observe(n); });
  /* click a column to replay its numeral */
  section.querySelectorAll('.py-col').forEach(c=>c.addEventListener('click',()=>redraw(document.getElementById('num'+c.dataset.col))));
})();


/* ---------- 15.5 · Ribbon — seamless marquee (same as Guardrails) ---------- */
(function(){
  const tracks=[...document.querySelectorAll('.pfr-track')];
  if(!tracks.length) return;
  const words=['Be read.','Be retold.','Be acted on.'];
  const half=[]; for(let i=0;i<8;i++) words.forEach(w=>half.push(w));
  const units=half.concat(half); /* duplicate so translateX(-50%) loops seamlessly */
  const html=units.map(w=>'<span class="pfr-unit"><span class="pfr-mk"><svg viewBox="0 0 58 54" aria-hidden="true"><use href="#gm"/></svg></span><span class="pfr-txt">'+w+'</span></span>').join('');
  tracks.forEach(track=>{ track.innerHTML=html; });
})();


/* ---------- 12 · Manifesto — fixed stage scaled to fit + page-turn (adapted from reference) ---------- */
(function(){
 document.querySelectorAll('.mf-stagewrap').forEach(function(wrap){
  const stage=wrap.querySelector('.mf-stage');
  const pagewin=wrap.querySelector('.mf-pagewin');
  const spine=wrap.querySelector('.mf-spine');
  const cast=wrap.querySelector('.mf-castshadow');
  const leaves=[...wrap.querySelectorAll('.mf-leaf')];
  const tabs=[...wrap.querySelectorAll('.mf-tab')];
  const SPINE=['#d2632b','#d8a147','#426443'];
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  const isMobile=()=>matchMedia('(max-width:1119px)').matches;   /* tablet usa el cuaderno estático del móvil; fit() sólo ≥1120 */
  const DUR=1050;
  let current=0, animating=false;

  /* scale the whole 1440x1014 stage to fit the viewport, never larger than 1:1 */
  function fit(){
    if(isMobile()){ wrap.style.transform=''; return; }
    const HEADER=72;                                   // leave room for the fixed header so it centres in the visible frame
    const s=Math.min(1, window.innerWidth/1440, (window.innerHeight-HEADER)/1014);
    wrap.style.transform='scale('+s+')';
  }
  fit();
  window.addEventListener('resize', fit, {passive:true});

  function setStatic(i){
    leaves.forEach((l,k)=>{ l.style.transform='none'; l.style.opacity=(k===i?'1':'0'); l.style.zIndex=(k===i?'5':'1');
      l.classList.toggle('show',k===i);
      l.querySelectorAll('.mf-shade').forEach(s=>s.style.opacity='0'); });
    tabs.forEach((t,k)=>t.classList.toggle('active',k===i));
    if(spine) spine.style.background=SPINE[i];
    if(cast){ cast.style.opacity='0'; cast.style.transform='none'; }
    current=i;
  }
  setStatic(0);

  /* one fluid page turn: a short corner-fold grab, then a continuous eased swing;
     the spine recolours after the sheet passes the binding, a soft shadow tracks the lift */
  function turn(leaf, forward, done, spineFrom, spineTo){
    const front=leaf.querySelector('.mf-face.front .mf-shade');
    const back =leaf.querySelector('.mf-face.back .mf-shade');
    const t0=performance.now();
    (function frame(now){
      let p=(now-t0)/DUR; if(p>1)p=1; if(p<0)p=0;
      const e = forward ? p : 1-p;
      let a;
      if(e<0.18){ a=(e/0.18)*0.06; }
      else { const k=(e-0.18)/0.82; a=0.06 + (1-Math.pow(1-k,2.3))*0.94; }
      leaf.style.transform='rotateY('+(-180*a).toFixed(2)+'deg)';
      const prog=a;
      if(spine) spine.style.background=(prog<0.58? spineFrom : spineTo);
      if(front&&back){
        if(prog<0.5){ front.style.opacity=(prog*2*0.8).toFixed(3); back.style.opacity='0'; }
        else { front.style.opacity='0'; back.style.opacity=(((prog-0.5)*2)*0.75).toFixed(3); }
      }
      const lift=Math.sin(prog*Math.PI);
      if(cast){ cast.style.opacity=(lift*0.75).toFixed(3); cast.style.transform='translateX('+(prog*44).toFixed(1)+'px) scaleX('+(1+lift*0.45).toFixed(3)+')'; }
      if(p<1){ requestAnimationFrame(frame); }
      else { if(front)front.style.opacity='0'; if(back)back.style.opacity='0'; if(cast){cast.style.opacity='0'; cast.style.transform='none';} done(); }
    })(performance.now());
  }

  function go(to){
    if(animating||to===current||to<0||to>=leaves.length) return;
    const from=current, forward=to>from;
    tabs.forEach((t,k)=>t.classList.toggle('active',k===to));
    if(reduced||isMobile()){ setStatic(to); return; }
    animating=true; pagewin.classList.add('turning');
    const cur=leaves[from], nxt=leaves[to];
    if(forward){
      nxt.style.opacity='1'; nxt.style.zIndex='2'; nxt.style.transform='none';
      cur.style.opacity='1'; cur.style.zIndex='6';
      turn(cur,true,()=>{ setStatic(to); pagewin.classList.remove('turning'); animating=false; }, SPINE[from], SPINE[to]);
    }else{
      cur.style.opacity='1'; cur.style.zIndex='2';
      nxt.style.opacity='1'; nxt.style.zIndex='6'; nxt.style.transform='rotateY(-180deg)';
      turn(nxt,false,()=>{ setStatic(to); pagewin.classList.remove('turning'); animating=false; }, SPINE[from], SPINE[to]);
    }
  }
  tabs.forEach((t,k)=>t.addEventListener('click',()=>go(k)));

  /* swipe on the notebook to turn pages (touch) — scoped so it never hijacks page scroll */
  let ty=null;
  stage.addEventListener('touchstart',e=>{ ty=e.touches[0].clientY; },{passive:true});
  stage.addEventListener('touchend',e=>{ if(ty===null)return; const dy=ty-e.changedTouches[0].clientY; if(Math.abs(dy)>40) go(current+(dy>0?1:-1)); ty=null; },{passive:true});
 });
})();


/* ---------- 04 · The Great Unlisting — scaled scene + scroll-driven beats (adapted from reference) ---------- */
(function(){
 document.querySelectorAll('.gu-frame').forEach(function(frame){
  const gu=frame.closest('.gu');
  const dias=[...gu.querySelectorAll('.gu-diamonds .gu-d')], bars=[...gu.querySelectorAll('.gu-diamonds .gu-bar')];
  const copyblocks=[...gu.querySelectorAll('.gu-copyblock')];
  const b1=gu.querySelector('.gu-b1'), b1six=gu.querySelector('.gu-six');
  const cardStage=gu.querySelector('.gu-cardStage');
  const rows=[...cardStage.querySelectorAll('.gu-crow')];
  const b3=gu.querySelector('.gu-b3'), b4=gu.querySelector('.gu-b4');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  const mobile=matchMedia('(max-width:1119px)').matches;   /* móvil + tablet: layout vertical, diamantes por tap */
  let current=0, countRun=false, countTimer=null, b3timer=null, rowTimers=[];

  /* Escala la escena para que entre en pantalla, sin superar 1:1.
     Desktop: lienzo 1440x620 (descuenta el header). Mobile (≤600): lienzo vertical 390x844
     → se escala a la altura real del teléfono, así nunca se desborda. */
  function fit(){
    let s;
    if(window.innerWidth<=1119){
      s=Math.min((window.innerWidth*0.98)/390, (window.innerHeight*0.995)/844);
    } else {
      const HEADER=72, MW=0.94, MH=0.9;
      s=Math.min(1, (window.innerWidth*MW)/1440, ((window.innerHeight-HEADER)*MH)/620);
    }
    frame.style.setProperty('--s', s);
  }
  fit();
  window.addEventListener('resize', fit, {passive:true});
  if(document.fonts&&document.fonts.ready){ document.fonts.ready.then(fit); }

  function setDiamonds(n){ dias.forEach(d=>d.classList.toggle('on',+d.dataset.d<=n)); bars.forEach(b=>b.classList.toggle('on',+b.dataset.b<n)); }
  function countUp(){
    if(countRun) return; countRun=true;
    if(reduced){ b1six.textContent='6'; return; }
    let v=0; clearInterval(countTimer);
    countTimer=setInterval(()=>{ v++; b1six.textContent=v; if(v>=6) clearInterval(countTimer); },80);
  }

  /* dibuja un glifo manuscrito (trazo por trazo) — misma técnica que 05 The Payoff */
  function drawHand(svg, startDelay){
    if(!svg) return 0;
    const group=svg.querySelector('mask > g');
    const strokes=group?[...group.querySelectorAll('path')]:[];
    const settle=group?group.querySelector('rect.settle'):null;
    /* mobile/tablet (≤1119px): sin animación — número final directo, sin trazo animado */
    if(matchMedia('(max-width:1119px)').matches){
      const depsNow=[...svg.querySelectorAll('g.reveal > g.dep')];
      if(settle) settle.setAttribute('opacity','1');
      depsNow.forEach(d=>d.setAttribute('opacity','1'));
      strokes.forEach(p=>{ p.style.visibility='visible'; });
      return 0;
    }
    const deps=[...svg.querySelectorAll('g.reveal > g.dep')];
    /* cancelar cualquier animación previa (al reentrar al beat 3 no se apilan trazos) */
    strokes.forEach(p=>p.getAnimations().forEach(a=>a.cancel()));
    if(settle) settle.getAnimations().forEach(a=>a.cancel());
    deps.forEach(d=>d.getAnimations().forEach(a=>a.cancel()));
    if(reduced){ if(settle) settle.setAttribute('opacity','1'); deps.forEach(d=>d.setAttribute('opacity','1')); return 0; }
    /* Respaldo mobile: si el SVG aún no tiene layout, getTotalLength() da 0 y la animación
       de trazo no dibuja nada → el número quedaría invisible. En ese caso mostramos el número
       final directamente (settle + deps a opacidad 1), garantizando que SIEMPRE se vea. */
    let __totLen=0; try{ strokes.forEach(p=>{ __totLen+=p.getTotalLength(); }); }catch(e){ __totLen=0; }
    if(__totLen===0){ if(settle) settle.setAttribute('opacity','1'); deps.forEach(d=>d.setAttribute('opacity','1')); strokes.forEach(p=>{ p.style.visibility='visible'; }); return 0; }
    if(settle) settle.setAttribute('opacity','0');
    deps.forEach(d=>d.setAttribute('opacity','0'));
    strokes.forEach(p=>{ const len=p.getTotalLength(); p.style.strokeDasharray=len; p.style.strokeDashoffset=len; p.style.visibility='visible'; });
    const SPEED=1100, GAP=30; let t=startDelay||0;
    strokes.forEach(p=>{ const len=p.getTotalLength(); const dur=Math.max(70,(len/SPEED)*1000); p.animate([{strokeDashoffset:len},{strokeDashoffset:0}],{duration:dur,delay:t,easing:'cubic-bezier(.42,.05,.58,.95)',fill:'forwards'}); t+=dur+GAP; });
    if(settle) settle.animate([{opacity:0},{opacity:1}],{duration:80,delay:Math.max(0,t-15),fill:'forwards'});
    deps.forEach(d=>d.animate([{opacity:0},{opacity:1}],{duration:150,delay:Math.max(0,t-30),fill:'forwards'}));
    return t+80;
  }
  function writeB3(){
    const five=gu.querySelector('.gu-b3grp.ga .gu-hand');
    const two=gu.querySelector('.gu-b3grp.gb .gu-hand');
    const rombo=gu.querySelector('.gu-b3rombo');
    if(reduced){ drawHand(five); drawHand(two); if(rombo) rombo.style.opacity=1; return; }
    const t5=drawHand(five,0);
    if(rombo){ rombo.getAnimations().forEach(a=>a.cancel()); rombo.style.opacity=0; const a=rombo.animate([{opacity:0},{opacity:1}],{duration:240,delay:Math.max(0,t5-40),fill:'forwards'}); a.onfinish=function(){ rombo.style.opacity=1; }; }
    drawHand(two, t5+120);
  }
  function goTo(n){
    if(n===current) return; current=n;
    /* ⚠️ cancelar timers pendientes: si no, al retroceder rápido el setTimeout del beat 3
       (que enciende los "5·2") se dispara cuando ya estás en otro beat → números fantasma. */
    clearTimeout(b3timer); rowTimers.forEach(clearTimeout); rowTimers=[];
    setDiamonds(n);
    gu.setAttribute('data-slide', n);   /* mobile: permite posición de diamantes por slide */
    copyblocks.forEach(c=>c.classList.toggle('on',+c.dataset.c===n));
    b1.classList.toggle('on', n===1);
    if(n===1){ countRun=false; b1six.textContent='0'; countUp(); }
    if(n===2){
      cardStage.classList.remove('hidden','at3'); cardStage.classList.add('at2');
      rows.forEach(r=>r.classList.remove('judged'));
      rows.forEach((r,i)=>rowTimers.push(setTimeout(()=>r.classList.add('judged'), i*90)));
      b3.classList.remove('on','write');
    } else if(n===3){
      cardStage.classList.remove('hidden','at2'); cardStage.classList.add('at3');
      b3timer=setTimeout(()=>{ b3.classList.add('on'); writeB3(); }, 350);
    } else {
      cardStage.classList.add('hidden');
      b3.classList.remove('on','write');
    }
    b4.classList.toggle('on', n===4);
  }

  /* Driver por PROGRESO de scroll: mido cuánto avanzó la escena dentro de su rango
     pineado y mapeo los 4 beats a umbrales exactos. Beat 1 arranca apenas la escena
     sube al tope (sin scroll muerto para llegar). Total ~1,8 pantallas (antes ~4,5). */
  const scroller = frame.closest('.gu-scroller');
  function beatAt(p){ return p>=0.82?4 : p>=0.57?3 : p>=0.30?2 : 1; }
  let guRaf=false;
  function drive(){
    if(guRaf) return; guRaf=true;
    requestAnimationFrame(function(){
      guRaf=false;
      const r=scroller.getBoundingClientRect(), vh=window.innerHeight;
      const total=scroller.offsetHeight - vh;
      if(total<=0 || r.top>vh*0.5 || r.bottom<0) return;   /* aún no llegó / ya pasó / vista oculta */
      const scrolled=Math.min(Math.max(-r.top,0), total);
      goTo(beatAt(scrolled/total));
    });
  }
  window.addEventListener('scroll', drive, {passive:true});
  window.addEventListener('resize', drive, {passive:true});
  drive();

  /* Diamantes clickeables: además del scroll, el usuario puede saltar a cada beat.
     Cada diamante lleva al punto de scroll de su beat (p en el medio de su rango). */
  const BEAT_P={1:0.12, 2:0.43, 3:0.69, 4:0.90};
  dias.forEach(function(d){
    d.setAttribute('role','button'); d.setAttribute('tabindex','0');
    d.setAttribute('aria-label','Ir al paso '+d.dataset.d+' de 4');
    function jump(){
      const n=+d.dataset.d, vh=window.innerHeight, total=scroller.offsetHeight - vh;
      if(total<=0) return;
      const top = window.scrollY + scroller.getBoundingClientRect().top + BEAT_P[n]*total;
      window.scrollTo({ top:Math.round(top), behavior:'smooth' });
    }
    d.addEventListener('click', jump);
    d.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); jump(); } });
  });
 });
})();



/* ---------- 08 · Who It Serves — fan-open spines + page-turn reading face ---------- */
(function(){
  const row = document.getElementById('wisRow');
  if(!row) return;
  const promptText = document.getElementById('wisPrompt');
  const CARDS = [
    { n:"01", name:"The Undersold Maker", nameLines:["The Undersold","Maker"], kicker:"Shopify / DTC",
      theme:"#0f3b34", numColor:"#d8a147", headColor:"#f0e9da", bodyColor:"#f0e9da", label:"#0f3b34",
      quote:"“My product is genuinely good, it’s just not selling and I can’t work out why.”",
      world:"Lucía makes necklaces from real stone, cut by hand, with a true sustainability story behind them. Her site says “timeless elegance”, and the story never lands. A shopper skims and leaves. A model retells her as “a jewellery brand”. An agent cannot tell why she costs more than the next tab.",
      answer:"Lucía’s page was never written for the readers who don’t open it directly. The model retelling her loses the reason she costs more, and the agent has nothing left to rank her on. The Diagnostic finds the exact sentences and structure responsible for each loss.",
      offer:"The Diagnostic · $1,000", planDesc:"Where the words fail, page by page, with proof." },
    { n:"02", name:"The Misread Challenger", nameLines:["The Misread","Challenger"], kicker:"B2B / tech",
      theme:"#426443", numColor:"#d8a147", headColor:"#f0e9da", bodyColor:"#f0e9da", label:"#426443",
      quote:"“I asked ChatGPT what we do and I didn’t recognise the answer.”",
      world:"Daniel’s tool is good, and the homepage is a fog of features. Ask a model what the product does and the answer is vague, or plain wrong. Meanwhile buyers form their view inside that model before they ever land on his site.",
      answer:"A model can only repeat the order Daniel’s page gives it, and right now there isn’t one. The Diagnostic finds exactly where that missing sequence costs him: what the product does, who it’s for, and why it’s different.",
      offer:"The Diagnostic · $1,000", planDesc:"The retelling gap, named, beside what you meant." },
    { n:"03", name:"The Trusted Expert", nameLines:["The Trusted","Expert"], kicker:"Boutique / advisory",
      theme:"#874535", numColor:"#d8a147", headColor:"#f0e9da", bodyColor:"#f0e9da", label:"#874535",
      quote:"“My reputation is real, but my website doesn’t reflect it.”",
      world:"Sofia runs a respected advisory. The expertise is genuine and the site reads like wallpaper: “trusted partners delivering outcomes”. A prospect learns nothing specific, and when someone asks an AI who is best in her niche, a clearer competitor is named instead.",
      answer:"Sofia’s expertise is specific. Her website’s language could belong to any advisory in her category. The Diagnostic finds every sentence built from that same generic vocabulary, and names the evidence missing behind each one.",
      offer:"The Diagnostic · $1,000", planDesc:"Where the authority goes unread, and the one or two repairs." },
    { n:"04", name:"The Founder’s Voice", nameLines:["The Founder’s","Voice"], kicker:"Scaling / rebrand",
      theme:"#d2632b", numColor:"#ebb865", headColor:"#f0e9da", bodyColor:"#f0e9da", label:"#d2632b",
      quote:"“Only I can write in our voice, and I can’t review every line forever.”",
      world:"Nadia writes the posts that land. Everyone else’s copy sounds slightly off, and now the AI tools the team uses write in the brand’s name and sound worse. The voice lives in her head, and the company is growing past the point where that can hold.",
      answer:"Right now the brand’s voice has exactly one point of failure: Nadia. Studio Start replaces that with a set of sourced rules built from her own writing, so growth stops depending on how many lines she can personally check.",
      offer:"Studio Start · $5,000", planDesc:"Your voice written into rules, by application." },
    { n:"05", name:"The Studio Partner", nameLines:["The Studio","Partner"], kicker:"Agency",
      theme:"#d8a147", numColor:"#2a0d02", headColor:"#5b321b", bodyColor:"#5b321b", label:"#c38e38",
      quote:"“Everyone sells dashboards. Where’s the part that actually does the work?”",
      world:"Clients keep asking the agency why they don’t show up in ChatGPT, and most of the market only has dashboards to offer. The agency needs an instrument it can prove, price and put its own name on.",
      answer:"Dashboards give an agency a number to forward. The Diagnostic gives it a signed, evidenced finding on every page, while the Toolkit gives it the same method to run again on the next client, turning both into a repeatable service line.",
      offer:"Diagnostic + Toolkit", planDesc:"The instrument and the method, to resell." }
  ];
  window.__wisCards = CARDS;   /* expuesto para la mecánica móvil/tablet (.wm-stack) */
  const ORNAMENT = '<svg viewBox="0 0 191 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6.5h78" stroke="currentColor" stroke-width="1" opacity=".7"/><path d="M113 6.5h78" stroke="currentColor" stroke-width="1" opacity=".7"/><path d="M95.5 1.5l4 5-4 5-4-5z" fill="currentColor"/></svg>';

  CARDS.forEach((c,i)=>{
    const card = document.createElement('div');
    card.className = 'wis-card';
    card.style.setProperty('--wis-theme', c.theme);
    card.style.setProperty('--wis-num-color', c.numColor);
    card.style.setProperty('--wis-head-color', c.headColor);
    card.style.setProperty('--wis-body-color', c.bodyColor);
    card.style.setProperty('--wis-label', c.label);
    card.dataset.index = i;
    card.innerHTML = `
      <div class="wis-spine">
        <div>
          <p class="wis-num">${c.n}</p>
          <p class="wis-name">${c.name}</p>
        </div>
        <div class="wis-spine-foot">
          <div class="wis-bar" style="background:${c.theme}"></div>
          <p class="wis-kicker">${c.kicker}</p>
        </div>
      </div>
      <div class="wis-hover">
        <div class="wis-top">
          <p class="wis-hnum">${c.n}</p>
          <p class="wis-hname">${c.nameLines.join('<br>')}</p>
          <div class="wis-ornament" style="color:${c.numColor}">${ORNAMENT}</div>
          <p class="wis-quote">${c.quote}</p>
        </div>
        <p class="wis-hkicker">${c.kicker}</p>
      </div>
      <div class="wis-read">
        <div class="wis-bspine"></div>
        <div class="wis-page">
          <div class="wis-page-inner">
            <div class="wis-read-block">
              <div class="wis-read-title">
                <div class="wis-hr"></div>
                <p class="wis-rt-label">${c.n} • ${c.name}</p>
                <div class="wis-hr"></div>
              </div>
              <div class="wis-read-sec">
                <p class="wis-lbl">Their world</p>
                <p class="wis-body">${c.world}</p>
              </div>
              <div class="wis-read-sec-hr"></div>
              <div class="wis-read-sec">
                <p class="wis-lbl">Our answer</p>
                <p class="wis-body">${c.answer}</p>
              </div>
            </div>
            <div class="wis-plan">
              <p class="wis-starts">Starts with</p>
              <p class="wis-offer">${c.offer}</p>
              <p class="wis-desc">${c.planDesc}</p>
              <a href="#free-score" class="wis-cta">Get your free score</a>
            </div>
          </div>
        </div>
      </div>`;
    row.appendChild(card);
  });

  const cards = [...row.querySelectorAll('.wis-card')];
  let openIndex = 0, flippedIndex = -1;
  const canHover = matchMedia('(hover:hover)').matches;   /* mouse: hover abre. táctil (tablet): 1er tap = tapa, 2do tap = contenido */

  function syncPrompt(){
    const isFlipped = cards[openIndex].classList.contains('flipped');
    if(promptText) promptText.textContent = isFlipped ? 'Touch to close' : 'Touch to open';
  }
  function setOpen(i){
    if(i === openIndex) return;
    cards[openIndex].classList.remove('open','flipped');
    if(flippedIndex === openIndex) flippedIndex = -1;
    openIndex = i;
    cards[openIndex].classList.add('open');
    syncPrompt();
  }
  cards[0].classList.add('open');
  syncPrompt();

  cards.forEach((card,i)=>{
    card.addEventListener('mouseenter', ()=>{ if(!canHover) return; if(flippedIndex !== -1) return; setOpen(i); });
    card.addEventListener('click', (e)=>{
      if(e.target.closest('.wis-cta')) return;          /* let the free-score link route home */
      if(i !== openIndex){ setOpen(i); return; }
      const nowFlipped = !card.classList.contains('flipped');
      card.classList.toggle('flipped', nowFlipped);
      flippedIndex = nowFlipped ? i : -1;
      syncPrompt();
    });
    card.tabIndex = 0; card.setAttribute('role','button');
    card.addEventListener('keydown',(e)=>{
      if(e.key==='ArrowRight'){ e.preventDefault(); const t=cards[Math.min(i+1,cards.length-1)]; setOpen(cards.indexOf(t)); t.focus(); }
      if(e.key==='ArrowLeft'){ e.preventDefault(); const t=cards[Math.max(i-1,0)]; setOpen(cards.indexOf(t)); t.focus(); }
      if(e.key==='Enter'||e.key===' '){ e.preventDefault(); card.click(); }
    });
  });
})();


/* ---------- 08 · Who It Serves — mecánica MÓVIL + TABLET (≤1119): libro cerrado → tapa → página ---------- */
(function(){
  const mq = matchMedia('(max-width:1119px)');
  const wis = document.querySelector('.wis');
  const CARDS = window.__wisCards;
  if(!wis || !CARDS) return;
  const inner = wis.querySelector('.wis-inner:not(.wis-headwrap)') || wis.querySelector('.wis-inner'); if(!inner) return;  /* el 2º .wis-inner (contenedor de la fila), no el header */
  const reduced = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const stack = document.createElement('div'); stack.className = 'wm-stack';
  inner.appendChild(stack);
  const ORN = '<div class="wm-orn"><span class="ln"></span><span class="di"></span><span class="ln"></span></div>';
  const isHoney = c => (c.theme||'').toLowerCase() === '#d8a147';
  const nodes = CARDS.map((c,i)=>{
    const el = document.createElement('div'); el.className='wm-card'; el.dataset.state='closed'; el.dataset.i=i;
    el.style.setProperty('--wm-theme', c.theme);
    el.style.setProperty('--wm-num', c.numColor);
    el.style.setProperty('--wm-ink', c.headColor || '#f0e9da');
    el.style.setProperty('--wm-offink', isHoney(c) ? '#2a0d02' : '#fff');
    el.style.setProperty('--wm-offmute', isHoney(c) ? 'rgba(42,13,0,.62)' : 'rgba(255,255,255,.78)');
    el.innerHTML = `
      <div class="wm-closed">
        <span class="wm-num">${c.n}</span>
        <p class="wm-name">${c.name}</p>
        <div class="wm-band"></div>
        <div class="wm-tag"><span>${c.kicker}</span></div>
      </div>
      <div class="wm-cover">
        <div class="wm-cnum">${c.n}</div>
        <div class="wm-cname">${c.name}</div>
        ${ORN}
        <p class="wm-quote">${c.quote}</p>
        <div class="wm-foot"><span>${c.kicker}</span> <span class="rd">· leer &#9662;</span></div>
      </div>
      <div class="wm-page">
        <div class="wm-spine"></div>
        <div class="wm-pin">
          <div class="wm-phd"><span>${c.n} &middot; ${c.name}</span><span class="x">&#10005;</span></div>
          <p class="wm-kk">Their world</p><p class="wm-pp">${c.world}</p>
          <p class="wm-kk">Our answer</p><p class="wm-pp">${c.answer}</p>
          <div class="wm-offer"><p class="st">Starts with</p><p class="of">${c.offer}</p><p class="od">${c.planDesc}</p><a href="#free-score" class="btn">Get your free score</a></div>
        </div>
      </div>`;
    stack.appendChild(el);
    return el;
  });
  let active = 0, mode = 'cover', lock = false;
  function fit(el){ const st = el.dataset.state; const box = el.querySelector('.wm-'+st); if(box) el.style.maxHeight = (box.scrollHeight + 6) + 'px'; }
  function apply(){ nodes.forEach((el,i)=>{ el.dataset.state = (i===active) ? mode : 'closed'; }); requestAnimationFrame(()=>nodes.forEach(fit)); }
  function openCover(i){ active=i; mode='cover'; lock=true; apply(); setTimeout(()=>lock=false, 650); }
  function openPage(i){ active=i; mode='page'; lock=true; apply(); const el=nodes[i]; setTimeout(()=>{ el.scrollIntoView({behavior: reduced?'auto':'smooth', block:'center'}); lock=false; }, 80); }
  function collapse(){ mode='cover'; apply(); }
  nodes.forEach((el,i)=>{
    el.addEventListener('click',(e)=>{
      if(!mq.matches) return;
      const st = el.dataset.state;
      if(st==='closed'){ openCover(i); }
      else if(st==='cover'){ openPage(i); }
      else if(st==='page'){ if(e.target.closest('.btn')) return; collapse(); }  /* cerrar tocando en cualquier lugar (menos el botón) */
    });
  });
  /* scroll-open: la ficha más cercana al centro del viewport se abre a tapa (salvo que haya página abierta) */
  let tick=false;
  window.addEventListener('scroll',()=>{
    if(!mq.matches || tick) return; tick=true;
    requestAnimationFrame(()=>{ tick=false;
      if(lock || mode==='page') return;
      const cy = innerHeight/2; let best=-1, bestd=1e9;
      nodes.forEach((el,i)=>{ const r=el.getBoundingClientRect(); if(r.height<10) return; const c=r.top+r.height/2; const d=Math.abs(c-cy);
        if(r.bottom>90 && r.top<innerHeight-40 && d<bestd){ bestd=d; best=i; } });
      if(best>=0 && best!==active){ active=best; mode='cover'; apply(); }
    });
  },{passive:true});
  function init(){ if(mq.matches) apply(); }
  requestAnimationFrame(init);
  window.addEventListener('load', ()=>setTimeout(init, 90));
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(()=>setTimeout(init, 50)); }
  if(mq.addEventListener) mq.addEventListener('change', ()=>{ if(mq.matches){ active=0; mode='cover'; apply(); } });
  window.addEventListener('resize', ()=>{ if(mq.matches) requestAnimationFrame(()=>nodes.forEach(fit)); });
})();


/* ---------- 09 · The Promises — twin marquees (right→left / left→right) ---------- */
(function(){
  const t1=document.getElementById('tprTrack1'), t2=document.getElementById('tprTrack2');
  if(!t1||!t2) return;
  const cards = {
    1:{n:"1",quote:"Sell more of what you already make, by putting into words what makes it worth the price.",
       caption:"The average Shopify store converts 1.4 to 1.8%. The top fifth clear 3.1%. That gap is usually fixable words."},
    2:{n:"2",quote:"Win the buyer before they reach your site, by making sure the AI that describes you gets you right.",
       caption:"The model’s version of you is often the first version a buyer sees.<br>We write the pages it reads."},
    3:{n:"3",quote:"Turn your best-fit AI traffic into sales, by saying on your page what the AI promised.",
       caption:"A buyer who arrives from an answer was pre-qualified before<br>your door opened."},
    4:{n:"4",quote:"Be the offer an agent can confirm and act on: a clear price, clear stock, a clear next step.",
       caption:"The category does not name the agent as a reader. We do."},
    5:{n:"5",quote:"Fix what loses you sales in about a week of work.",
       caption:"A page-by-page fix list, each change sized as a task."},
    6:{n:"6",quote:"Keep every tool and hire on-brand, by turning your voice into rules people and tools follow.",
       caption:"Sourced rules, drawn from your own best lines, hold the voice steady."}
  };
  function cardHTML(c){
    return `<div class="tpr-card"><div class="tpr-num"><span>${c.n}</span></div><div class="tpr-body"><div class="tpr-rule"></div><div class="tpr-text"><p class="tpr-quote">${c.quote}</p><p class="tpr-caption">${c.caption}</p></div><div class="tpr-rule"></div></div></div>`;
  }
  const order1=[1,2,3,4,5,6], order2=[6,5,4,3,2,1];
  const strip=(o)=>`<div class="tpr-strip">${o.map(i=>cardHTML(cards[i])).join("")}</div>`;
  t1.innerHTML = strip(order1) + strip(order1);
  t2.innerHTML = strip(order2) + strip(order2);
})();



(function(){var b=document.getElementById("heroReadOn");if(!b)return;b.addEventListener("click",function(){var t=document.getElementById("homeStats");if(t)t.scrollIntoView({behavior:"smooth",block:"start"});});})();
/* 02 Hero — encender la cascada de entrada al cargar la home */
(function(){
  var hero=document.querySelector('.pageview[data-view="home"] .hero');
  if(!hero) return;
  var reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduced){ hero.classList.add('hero-lit'); return; }
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ hero.classList.add('hero-lit'); }); });
})();
/* 03 Stats — números que cuentan de 0 al valor al entrar en pantalla */
(function(){
  var reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var easeOutExpo=function(x){ return x>=1?1:1-Math.pow(2,-10*x); };
  function fmt(v,dec){ return dec>0 ? v.toFixed(dec) : Math.round(v).toString(); }
  function run(num){
    var val=num.querySelector('.hstat-val'); if(!val) return;
    var to=parseFloat(num.dataset.count), dec=parseInt(num.dataset.dec||'0',10);
    if(isNaN(to)) return;
    if(reduced){ val.textContent=fmt(to,dec); return; }
    var D=1500, t0=performance.now();
    (function frame(now){
      var p=Math.min(1,(now-t0)/D);
      val.textContent=fmt(easeOutExpo(p)*to, dec);
      if(p<1) requestAnimationFrame(frame);
    })(performance.now());
  }
  document.querySelectorAll('.hstat-cards').forEach(function(block){
    var nums=[].slice.call(block.querySelectorAll('.hstat-num[data-count]'));
    if(!nums.length) return;
    var fired=false;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting && !fired){
          fired=true; io.disconnect();
          nums.forEach(function(n,i){ setTimeout(function(){ run(n); }, i*140); });
        }
      });
    },{threshold:.35});
    io.observe(block);
  });
})();
/* Entradas de frame: enciende Services (.px-pricing) y Manifesto (.mf) al entrar en pantalla */
(function(){
  [['.px-pricing','px-lit'],['.mf','mf-lit'],['.wis','wis-lit']].forEach(function(pair){
    document.querySelectorAll(pair[0]).forEach(function(el){
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ el.classList.add(pair[1]); io.unobserve(el); } }); },{threshold:.15});
      io.observe(el);
    });
  });
})();


(function(){
  var header=document.getElementById('siteHeader'); if(!header) return;
  function update(){
    var hv=document.querySelector('.pageview[data-view="home"]');
    var iso=hv?hv.querySelector('.hero .hero-iso'):null;
    if(!hv||hv.hidden||!iso){ header.classList.remove('logo-hidden'); return; }
    var past=iso.getBoundingClientRect().bottom<=72;   /* the hero's own isotype has tucked behind the fixed header */
    header.classList.toggle('logo-hidden', !past);
  }
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  window.addEventListener('load',update);
  update();
})();


/* NEWS — búsqueda + filtros (scoped a .news) */
(function(){
  var root=document.querySelector('.pageview.news'); if(!root) return;
  var chips=[].slice.call(root.querySelectorAll('.chip'));
  var input=root.querySelector('.search input');
  var cards=[].slice.call(root.querySelectorAll('.card'));
  var empty=root.querySelector('.feed-empty');
  var activeKind='all';
  function apply(){
    var q=((input&&input.value)||'').trim().toLowerCase();
    var shown=0;
    cards.forEach(function(c){
      var k=c.getAttribute('data-kind')||'';
      var t=c.getAttribute('data-title')||'';
      var okKind=(activeKind==='all')||(k===activeKind);
      var okText=!q||t.indexOf(q)>-1;
      var show=okKind&&okText;
      c.classList.toggle('is-hidden',!show);
      if(show)shown++;
    });
    if(empty)empty.classList.toggle('show',shown===0);
  }
  chips.forEach(function(c){c.addEventListener('click',function(){
    chips.forEach(function(x){x.classList.remove('is-on');});
    c.classList.add('is-on');
    activeKind=c.getAttribute('data-f');
    apply();
  });});
  if(input)input.addEventListener('input',apply);

  /* botón "volver arriba" (móvil): aparece al scrollear; vive en .news-main → solo se ve en News */
  var toTop=root.querySelector('.news-totop');
  if(toTop){
    var onScroll=function(){ toTop.classList.toggle('is-visible', (window.scrollY||window.pageYOffset||0)>500); };
    window.addEventListener('scroll',onScroll,{passive:true});
    onScroll();
    toTop.addEventListener('click',function(){ window.scrollTo({top:0,behavior:'smooth'}); });
  }
})();



/* ============================================================
   RED DE SEGURIDAD GLOBAL · números manuscritos (Payoff + Great Unlisting)
   Problema observado en mobile Y tablet: los números (5·2 del Great Unlisting,
   +33%/~2x/… del Payoff) a veces no se dibujan porque su disparo depende del
   scroll/beat, que no siempre ocurre. Este respaldo es INCONDICIONAL: garantiza
   que NUNCA quede un hueco vacío, pintando el número final si la animación propia
   no corrió. No reemplaza la animación de pluma cuando ésta sí funciona.
   ============================================================ */
(function(){
  function paintFinal(svg){
    if(!svg) return;
    svg.querySelectorAll('rect.settle').forEach(function(r){ r.setAttribute('opacity','1'); r.style.opacity='1'; });
    svg.querySelectorAll('g.reveal > g.dep, g.reveal g.dep').forEach(function(d){ d.setAttribute('opacity','1'); d.style.opacity='1'; });
    svg.querySelectorAll('g.reveal > text, g.reveal text').forEach(function(t){ t.style.opacity='1'; t.style.visibility='visible'; });
    svg.querySelectorAll('mask > g path, mask g path').forEach(function(p){ p.style.visibility='visible'; });
  }
  function isPainted(svg){
    var el=svg.querySelector('g.reveal g.dep, rect.settle');
    if(!el) return false;
    return parseFloat(getComputedStyle(el).opacity)>0.5;
  }
  function ensure(svg, delay){
    if(!svg) return;
    setTimeout(function(){ if(!isPainted(svg)) paintFinal(svg); }, delay==null?900:delay);
  }

  /* --- The Payoff: observar cada número; al asomar, garantizar dibujo --- */
  function wirePayoff(){
    var svgs=[].slice.call(document.querySelectorAll('.py-num svg.hand'));
    if(!svgs.length) return;
    if(!('IntersectionObserver' in window)){ svgs.forEach(function(s){ paintFinal(s); }); return; }
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ ensure(e.target); } }); },{threshold:0});
    svgs.forEach(function(s){ io.observe(s); });
  }

  /* --- Great Unlisting: el 5·2 vive en .gu-b3, que arranca display:none y se
     activa (clase 'on') al llegar al beat 3. Observamos esa clase: en cuanto
     .gu-b3 se vuelve visible, garantizamos el dibujo aunque writeB3 no corra. --- */
  function wireGreatUnlisting(){
    document.querySelectorAll('.gu-b3').forEach(function(b3){
      function check(){
        if(b3.classList.contains('on')){
          b3.querySelectorAll('.gu-hand').forEach(function(svg){ ensure(svg, 1000); });
        }
      }
      var mo=new MutationObserver(check);
      mo.observe(b3,{attributes:true, attributeFilter:['class']});
      check();
    });
    /* respaldo extra: si el usuario llega al beat 3 por scroll pero writeB3 midió
       en display:none, forzamos un repaint cuando la sección esté bien visible */
    document.querySelectorAll('.gu').forEach(function(gu){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){
            var b3=gu.querySelector('.gu-b3');
            if(b3 && b3.classList.contains('on')){
              b3.querySelectorAll('.gu-hand').forEach(function(svg){ ensure(svg, 200); });
            }
          }
        });
      },{threshold:0.2});
      io.observe(gu);
    });
  }

  /* --- Cuando una pageview se muestra, revisamos sus números --- */
  function wireViews(){
    document.querySelectorAll('.pageview').forEach(function(pv){
      var mo=new MutationObserver(function(){
        if(pv.hidden) return;
        setTimeout(function(){
          pv.querySelectorAll('.py-num svg.hand').forEach(function(svg){
            var r=svg.getBoundingClientRect();
            if(r.top < (window.innerHeight||800) && r.bottom > 0) ensure(svg, 300);
          });
          var b3=pv.querySelector('.gu-b3');
          if(b3 && b3.classList.contains('on')) b3.querySelectorAll('.gu-hand').forEach(function(svg){ ensure(svg,300); });
        }, 400);
      });
      mo.observe(pv,{attributes:true, attributeFilter:['hidden']});
    });
  }

  function wire(){ wirePayoff(); wireGreatUnlisting(); wireViews(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', wire, {once:true}); }
  else { wire(); }
})();

  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", __twhInit, { once: true });
  } else { __twhInit(); }
})();
